"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('application', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(5.000000, 6.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polyline", {
    strokeLinecap: props.strokeLinecap,
    points: "35.0393664 16 35.0393664 36 3.03936636 36 3.03936636 16"
  }), _react.default.createElement("path", {
    d: "M5.0972668,16 L6.52764829,16 C9.84135679,16 12.5276483,13.3137085 12.5276483,10 L12.5276483,10 C12.5276483,13.3137085 15.2139398,16 18.5276483,16 L19.5460157,16 C22.8597242,16 25.5460157,13.3137085 25.5460157,10 L25.5460157,10 C25.5460157,13.3137085 28.2323072,16 31.5460157,16 L32.980292,16 C35.7957382,16 38.0781083,13.7176299 38.0781083,10.9021836 C38.0781083,10.2739777 37.9619956,9.65118266 37.7356211,9.06518161 L34.2337065,-1.10134124e-13 L3.84522501,-1.10134124e-13 L0.343478179,9.06844753 C-0.670327498,11.6938925 0.636164281,14.644088 3.26160924,15.6578937 C3.84720124,15.8840179 4.46953269,16 5.0972668,16 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  })))));
});

exports.default = _default;